import { FC } from "react";

import { Result } from "antd";

const ErrorPage: FC = () => {
  return <Result status="404" title="404" subTitle={''} />;
};

export default ErrorPage;
